import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import confetti from "canvas-confetti";
import BackButton from "./Backbutton";
import Title from "./Title";
import { EVENT_BASEURL } from "../../utils/Constants";
import { apiHandler } from "../../utils/apiHandler";
import { useParams } from "react-router-dom";





const transformQuizData = (apiResponse) => {

  let NewUsername = "";

  const pathArray = window.location.pathname.split("/").filter(Boolean);

  if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
  } else {
    NewUsername = pathArray[0]
  }

  let data2 = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
  const newImgUrl = `https://welcometowedding.com/events/${data2?._id}/`
  console.log(newImgUrl);

  let quizData = apiResponse.qzQuestions.map((question, index) => {
    const correctType = question.quizCorrectOption.replace("OPT-", ""); // A, B, C, D

    // A->1, B->2, C->3, D->4 mapping
    const correctId =
      correctType === "A"
        ? "1"
        : correctType === "B"
          ? "2"
          : correctType === "C"
            ? "3"
            : "4";

    return {
      id: index,
      title: question.quizQues,
      correctAnswerId: correctId,
      content: question.quizQues,
      img: `${newImgUrl + question.quizBgImg}`,
      options: [
        { optionName: question.quizOptionA, id: "1", type: "A" },
        { optionName: question.quizOptionB, id: "2", type: "B" },
        { optionName: question.quizOptionC, id: "3", type: "C" },
        { optionName: question.quizOptionD, id: "4", type: "D" },
      ],
      correctoption: correctId,
    };
  });


  quizData.push({
    id: quizData.length,
    title: apiResponse.qzEndHeading || "Quiz Result",
    correctAnswerId: null,
    content: apiResponse.qzResultTitle,
    text: apiResponse.qzRule, // Default fallback
    resultMessages: {
      zero: apiResponse.qzrZero,
      zeroToNine: apiResponse.qzrZeroToNine,
      tenToNinteen: apiResponse.qzrTenToNinteen,
      twentyToTwentyNine: apiResponse.qzrTwentyToTwentyNine,
      thirtyToThirtyNine: apiResponse.qzrThirtyToThirtyNine,
      fourtyToFourtyNine: apiResponse.qzrFourtyToFourtyNine,
      fiftyToFiftyNine: apiResponse.qzrFiftyToFiftyNine,
      sixtyToSixtyNine: apiResponse.qzrSixtyToSixtyNine,
      seventyToSeventyNine: apiResponse.qzrSeventyToSeventyNine,
      eightyToEightyNine: apiResponse.qzrEightyToEightyNine,
      ninetyToHundread: apiResponse.qzrNinetyToHundread,
    },
    img: `${newImgUrl + apiResponse.qzWebImg}`,
  });
  // Duplicate the first element at index 1
  quizData.splice(0, 0, { ...quizData[4] });

  // Now reset ids to match their new positions
  quizData = quizData.map((item, index) => ({ ...item, id: index }));

  console.log(quizData);

  return quizData;
};

const allData = JSON.parse(localStorage.getItem("quizgame"));

const quizData = allData && allData[0];
const Quiz = () => {



  const optionImages = {
    A: "/img/ic_a.svg",
    B: "/img/ic_b.svg",
    C: "/img/ic_c.svg",
    D: "/img/ic_d.svg",
  };
  const { id } = useParams();
  const [Data, setData] = useState([]);
  const [webSubtitle, setWebSubtitle] = useState(allData && allData[1] ? allData[1].qzWebSubtitle : "");
  const [webTitle, setWebTitle] = useState(allData && allData[1] ? allData[1].qzWebTitle : "");
  const [autoplay, setAutoplay] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [answerPicked, setAnswerPicked] = useState(false);
  const [shake, setShake] = useState(false);
  const [shakes, setIsShaking] = useState(false);
  const [forward, setforward] = useState(false);
  const [yourscore, setyourscore] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentSlidees, setcurrentSlidees] = useState(0);
  const [showanimation, setshowanimation] = useState(0);
  const [progress, setProgress] = useState(Array(Data.length).fill(0));
  const [isProgressActive, setIsProgressActive] = useState(
    Array(Data.length).fill(false)
  );
  const [isBlurred, setIsBlurred] = useState(true);
  const [isImageLoaded, setIsImageLoaded] = useState(true);
  const sliderRef = useRef(null);
  const sliderRef1 = useRef(null);
  const divRef = useRef();

  let NewUsername = "";

  const pathArray = window.location.pathname.split("/").filter(Boolean);

  if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
  } else {
    NewUsername = pathArray[0]
  }

  let data2 = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
  const newImgUrl = `https://welcometowedding.com/events/${data2?._id}/`
  console.log(newImgUrl);

  useEffect(() => {
    // Unblur after 1 second (adjust delay as needed)
    const timer = setTimeout(() => {
      setIsBlurred(false);
    }, 200);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [Data]);


  useEffect(() => {
    const fetchSquad = async () => {
      try {
        const res = await apiHandler.post("/guest/fetch-feature", {
          _id: id,
          category: "QuizGame"
        });
        console.log(res);
        if (res) {
          if (quizData === null) {
            const data = transformQuizData(res);
            console.log('Hiii')
            setData(data);
            setWebSubtitle(res.qzWebSubtitle);
            setWebTitle(res.qzWebTitle);
          } else {
            setData(quizData);
          }

        }
      } catch (err) {
        console.error("Guest login error:", err);
      }
    };

    fetchSquad();
  }, [])


  const handleButtonClick = (data) => {
    if (data.id === 0) {
      console.log("yes");
      if (sliderRef.current) {
        setTimeout(() => {
          if (sliderRef.current) {
            sliderRef.current.slickNext();
            setAutoplay(true);
          }
        }, 20);
        setAutoplay(false);
      }
    } else {
      if (sliderRef.current) {
        setTimeout(() => {
          if (sliderRef.current) {
            sliderRef.current.slickNext();
            setAutoplay(true);
          }
        }, 2000);
        setAutoplay(false);
      }
    }
    if (data.id === 0) {
      console.log("yes");
      if (sliderRef1.current) {
        setTimeout(() => {
          if (sliderRef1.current) {
            sliderRef1.current.slickNext();
            setAutoplay(true);
          }
        }, 20);
        setAutoplay(false);
      }
    } else {
      if (sliderRef1.current) {
        setTimeout(() => {
          if (sliderRef1.current) {
            sliderRef1.current.slickNext();
            setAutoplay(true);
          }
        }, 2000);
        setAutoplay(false);
      }
    }
  };

  useEffect(() => {
    console.log("Current Slide:", currentSlide);
  }, [currentSlide]);

  const triggerConfetti = () => {
    const isMobile = window.matchMedia("(max-width: 1024px)").matches;

    // Create a separate canvas element
    const confettiCanvas = document.createElement("canvas");
    confettiCanvas.style.position = "absolute";
    confettiCanvas.style.top = "0";
    confettiCanvas.style.left = "0";
    confettiCanvas.style.width = "100%";
    confettiCanvas.style.height = "100%";
    confettiCanvas.style.pointerEvents = "none"; // Prevent interaction with canvas
    document.body.appendChild(confettiCanvas);

    const confettiInstance = confetti.create(confettiCanvas, {
      resize: true,
      useWorker: true,
    });

    confettiInstance({
      particleCount: 50,
      spread: 50,
      origin: {
        x: isMobile ? 0.5 : 0.7,
        y: 0.7,
      },
      shapes: ["circle"],
      scalar: 1,
    });

    // Remove the canvas after the confetti has been shown for a while
    setTimeout(() => {
      document.body.removeChild(confettiCanvas);
    }, 3000); // Adjust time as needed
  };


  const [selectedOptions, setSelectedOptions] = useState({});
  const [isSubmittedState, setIsSubmittedState] = useState({});

  const handleOptionClick = (optionId, index) => {
    if (!isSubmittedState[index]) {
      const correctOptionId = Data[index].correctoption;
      const isCorrect = optionId === correctOptionId;

      // Save the selected option and the correct option for the current slide
      setSelectedOptions((prevSelected) => ({
        ...prevSelected,
        [index]: {
          optionId,
          isCorrect,
          correctOptionId,
        },
      }));

      setIsSubmittedState((prevSubmitted) => ({
        ...prevSubmitted,
        [index]: true,
      }));

      setSelectedOption(optionId);
      setIsProgressActive((prevState) => {
        const newState = [...prevState];
        newState[index] = true;
        return newState;
      });

      setIsSubmitted(true);
      setAnswerPicked(true);

      if (isCorrect) {
        setforward(true);
        setshowanimation(true);
        triggerConfetti();

        setTimeout(() => {
          setforward(false);
        }, 1500);

        setTimeout(() => {
          setshowanimation(false);
        }, 100);

        let scoreEachQuestions = 100 / (Data.length - 2)
        setyourscore((prevScore) => prevScore + scoreEachQuestions);
        setIsShaking(true);

        setTimeout(() => {
          setIsShaking(false);
        }, 800); // Duration of the shaking animation
      } else {
        setShake(true);
        setTimeout(() => {
          setShake(false);
        }, 600);
      }

      handleButtonClick(Data[index]);
    }
  };

  const getOptionClass = (optionId, slideIndex) => {
    const selected = selectedOptions[slideIndex];
    if (selected && selected.optionId === optionId) {
      return selected.isCorrect ? "correct" : "wrong ";
    } else if (selected && selected.optionId === optionId) {
      return "correct";
    }

    return "";
  };

  const settings = {
    className: "center",
    centerMode: false,
    infinite: false,
    speed: 1000,
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    draggable: false,
    swipe: false,
    touchMove: false,
    beforeChange: (oldIndex, newIndex) => {
      setAutoplay(false);
      setSelectedOption(null);
      setAnswerPicked(false);
      setIsSubmitted(false);
      setCurrentSlide(newIndex);
    },
    afterChange: () => setAutoplay(true),
  };

  const settings1 = {
    className: "center",
    centerMode: false,
    infinite: false,
    speed: 1000,
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    draggable: false,
    swipe: false,
    touchMove: false,
    beforeChange: (oldIndex, newIndex) => {
      setSelectedOption(null);
      setAnswerPicked(false);
      setIsSubmitted(false);
      setCurrentSlide(newIndex);
    },
    afterChange: (index) => {
      setCurrentSlide(index);
      setAutoplay(true);
    },
  };

  useEffect(() => {
    let interval;
    if (
      isProgressActive[currentSlide] &&
      currentSlide > 0 &&
      currentSlide < Data.length - 1
    ) {
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          const newProgress = [...prevProgress];
          newProgress[currentSlide] = Math.min(
            newProgress[currentSlide] + 10,
            120
          ); // Increase progress by 10%
          return newProgress;
        });
      }, 150); // Update progress every second
    }

    return () => clearInterval(interval);
  }, [isProgressActive, currentSlide, Data.length]);

  useEffect(() => {
    if (progress[currentSlide] >= 120) {
      sliderRef.current.slickNext();
    }
  }, [progress, currentSlide]);

  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (currentSlide !== 0 && currentSlide !== Data.length - 1) {
      const timer = setTimeout(() => {
        setShowContent(true);
      }, 345);
      return () => clearTimeout(timer);
    } else {
      setShowContent(false);
    }
  }, [currentSlide, Data.length]);
  useEffect(() => {
    if (Data.length > 0) {
      setProgress(Array(Data.length).fill(0));
      setIsProgressActive(Array(Data.length).fill(false));
    }
  }, [Data]);

  return (
    <div
      className="flex w-full items-center bg-white joureney p-0 overflow-hidden Quiz "
      style={{
        position: "relative",
        width: "100svh",
        height: "100svh",
        overflow: "hidden",
      }}
      ref={divRef}

    >
      <div
        className=" grid grid-cols-12  justify-between items-center  h-screen hideinmobile"
        style={{ width: "100%", height: "100svh" }}
      >
        <div
          className="w-full col-span-5  ourstoryfirst bg-black text-white h-screen flex flex-col justify-evenly items-center p-0 position-relative "
          style={{ height: "100svh" }}
        >
          <div className="flex flex-col justify-evenly items-center  ourstory  ">



            <Title title={"Quiz"} />
          </div>

          {/* <div
            className="main-slider firstsliderjoureny   "
            sstyle={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
          ></div> */}
          <div className="SliderJoureny text-center flex justify-center flex-col items-center p-0 ">
            <div
              className="pb-2"
              style={{
                fontSize: "1.5rem",
                fontWeight: "550",
                wordSpacing: "5px",
              }}
            >
              {webTitle}{" "}
            </div>
            <div
              className=" style-script-regular mb-0 pt-2"
              style={{ fontSize: "2.5rem", fontWeight: "550" }}
            >
              {webSubtitle}
            </div>
          </div>

          <div>
            <img src="/img/manimage.jpg"
              className={`
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }
											`}
              onLoad={() => setIsImageLoaded(false)}
              alt="" />
          </div>
          <div style={{ fontSize: "25px" }}>
            <button
              className={`bg-white hover:bg-blue-700 text-red-500 font-bold py-2 px-4 rounded-4 flex items-center ${shakes ? "bounce2" : ""
                } `}
            >
              You Score{" "}
              <div className="pl-2 pr-1">
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 24 24"
                  fill="#e74c3c" /* Desired color */
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                </svg>
              </div>
              <span
                className="pl-1"
                style={{
                  color: "#e74c3c",
                  fontSize: "30px",
                  fontWeight: "600",
                  display: "inline-block",
                }}
              >
                {" "}
                {yourscore}
              </span>{" "}
            </button>
          </div>
        </div>
        <div
          className="md:col-span-7 "
          style={{ height: "100svh", maxWidth: "100%", width: "100%" }}
        >
          <Slider
            {...settings}
            ref={sliderRef}
            style={{
              height: "100svh",
              maxWidth: "100svh",
              maxWidth: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {Data.map((data, index) => (
              <div key={data.id}>
                <div className="p-0 innerdivGroomSquad" style={{ width: "100%" }}>
                  <div
                    className="p-5 flex justify-center flex-col items-center cardofslider relative"
                    style={{ width: "100%", zIndex: "999" }}
                  >
                    {/* 🔥 Background Image Layer with <img> */}
                    <img
                      src={data.img}
                      alt={data.title}
                      className={`absolute top-0 left-0 w-full h-full object-cover transition-all duration-1000 ${isBlurred ? "blur-lg scale-105" : "blur-0 scale-100"
                        }`}
                      style={{
                        borderRadius: "inherit", // matches parent rounded corners
                        zIndex: 0,
                      }}
                      onLoad={() => setIsImageLoaded(false)}
                    />

                    {/* 🔥 Progress Bar at top, centered */}
                    {!(data.id === 0 || data.id === Data[Data.length - 1].id) && (
                      <>
                        <div
                          className="progress-line-background absolute top-4 left-1/2 z-10"
                          style={{
                            width: "80%",
                            transform: "translateX(-50%)",
                          }}
                        ></div>
                        <div
                          className={`progress-line absolute top-4  z-20 ${answerPicked ? "fill" : ""}`}

                        ></div>
                      </>
                    )}

                    {/* 🔥 Foreground Content (Always Sharp) */}
                    <div className="relative z-10 w-full">
                      <div
                        style={{ width: "100%" }}
                        className={`quiz ${shake ? "shake" : `${forward ? "forward" : ""}`}`}
                      >
                        <div
                          className="bg-black p-4 text-white text-center"
                          style={{ fontSize: "18px", fontWeight: "600" }}
                        >
                          {data.title}
                          <br />
                          {data.line}
                        </div>

                        <div className="p-2 px-3 flex flex-col items-center justify-center">
                          {data.id === Data[0].id || data.id === Data[Data.length - 1].id ? (
                            <>
                              <div className="p-1">
                                {data.id === Data[Data.length - 1].id && (
                                  <img
                                    src={data.img}
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      borderRadius: "50%",
                                    }}
                                    className={`transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                                      }`}
                                    onLoad={() => setIsImageLoaded(false)}
                                    alt=""
                                  />
                                )}
                              </div>

                              <p
                                className="mb-1 px-3"
                                style={{
                                  fontWeight: "550",
                                  textAlign: "center",
                                  textAlignLast: "center",
                                  color: data.id === Data[0].id ? "#545454" : "",
                                }}
                              >
                                {(() => {
                                  if (data.id === Data[Data.length - 1].id) {
                                    const score = yourscore;
                                    const messages = data.resultMessages;
                                    if (!messages) return data.text;

                                    if (score === 0) return messages.zero;
                                    if (score < 10) return messages.zeroToNine;
                                    if (score < 20) return messages.tenToNinteen;
                                    if (score < 30) return messages.twentyToTwentyNine;
                                    if (score < 40) return messages.thirtyToThirtyNine;
                                    if (score < 50) return messages.fourtyToFourtyNine;
                                    if (score < 60) return messages.fiftyToFiftyNine;
                                    if (score < 70) return messages.sixtyToSixtyNine;
                                    if (score < 80) return messages.seventyToSeventyNine;
                                    if (score < 90) return messages.eightyToEightyNine;
                                    return messages.ninetyToHundread;
                                  }
                                  return data.text;
                                })()}
                              </p>

                              <p
                                className="mb-1"
                                style={{
                                  fontWeight: "400",
                                  fontSize: "15px",
                                  textAlign: "justify",
                                  textAlignLast: "center",
                                }}
                              >
                                {/* {(() => {
                            if (data.id === Data[Data.length - 1].id) {
                              const score = yourscore;
                              const messages = data.resultMessages;
                              if (!messages) return data.text;

                              if (score === 0) return messages.zero;
                              if (score < 10) return messages.zeroToNine;
                              if (score < 20) return messages.tenToNinteen;
                              if (score < 30) return messages.twentyToTwentyNine;
                              if (score < 40) return messages.thirtyToThirtyNine;
                              if (score < 50) return messages.fourtyToFourtyNine;
                              if (score < 60) return messages.fiftyToFiftyNine;
                              if (score < 70) return messages.sixtyToSixtyNine;
                              if (score < 80) return messages.seventyToSeventyNine;
                              if (score < 90) return messages.eightyToEightyNine;
                              return messages.ninetyToHundread;
                            }
                            return data.text;
                          })()} */}
                              </p>

                              {data.id === Data[Data.length - 1].id ? (
                                <div
                                  className="-500 font-bold rounded p-2 flex items-center flex-col"
                                  style={{ width: "100%" }}
                                >
                                  <div className="flex justify-center items-center">
                                    You Score:{" "}
                                    <div className="pl-2 pr-1">
                                      <svg
                                        width="25"
                                        height="25"
                                        viewBox="0 0 24 24"
                                        fill="#e74c3c"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                      </svg>
                                    </div>
                                    <span
                                      style={{
                                        color: "#e74c3c",
                                        fontSize: "22px",
                                        fontWeight: "600",
                                        display: "inline-block",
                                      }}
                                    >
                                      {yourscore}
                                    </span>
                                  </div>

                                  <BackButton style={{ width: "100%", borderRadius: "20px" }}>
                                    <button
                                      className="text-white p-1 buttonripple"
                                      style={{
                                        width: "100%",
                                        borderRadius: "20px",
                                        backgroundColor: "#e74c3c",
                                        fontWeight: "500",
                                        textTransform: "uppercase",
                                      }}
                                      onClick={() => handleButtonClick(data)}
                                    >
                                      Exit
                                    </button>
                                  </BackButton>
                                </div>
                              ) : (
                                <button
                                  className="text-white p-1 m-2 buttonripple"
                                  style={{
                                    width: "90%",
                                    borderRadius: "20px",
                                    backgroundColor: "#1BD04F",
                                  }}
                                  onClick={() => handleButtonClick(data)}
                                >
                                  <span style={{ position: "relative", zIndex: 1 }}>Start Quiz</span>
                                </button>
                              )}
                            </>
                          ) : (
                            <>
                              {data.options.map((option) => (
                                <div
                                  key={option.id}
                                  className={`option buttonripple ${getOptionClass(option.id, index)}`}
                                  onClick={() => handleOptionClick(option.id, index)}
                                  style={{
                                    backgroundColor:
                                      option.id === selectedOptions[index]?.correctOptionId
                                        ? "#1BD04F"
                                        : option.id === selectedOptions[index]?.optionId
                                          ? "#e74c3c"
                                          : "transparent",
                                    color:
                                      option.id === selectedOptions[index]?.correctOptionId
                                        ? "white"
                                        : option.id === selectedOptions[index]?.optionId
                                          ? "white"
                                          : "#545454",
                                    borderColor:
                                      option.id === selectedOptions[index]?.correctOptionId
                                        ? "#1BD04F"
                                        : option.id === selectedOptions[index]?.optionId
                                          ? "#e74c3c"
                                          : "",
                                  }}
                                >
                                  <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                                    {/* SVG / check logic */}
                                    {isSubmittedState[index] ? (
                                      <>
                                        {option.id === selectedOptions[index]?.correctOptionId ? (
                                          <img
                                            src="/img/insta_check.svg"
                                            alt="Correct"
                                            style={{
                                              height: "30px",
                                              margin: "0px 10px 0px 0px",
                                              filter: "invert(1) brightness(100%)",
                                            }}
                                          />
                                        ) : option.id === selectedOptions[index]?.optionId ? (
                                          <img
                                            src="/img/insta_cancel.svg"
                                            alt="Wrong"
                                            style={{
                                              height: "30px",
                                              margin: "0px 10px 0px 0px",
                                              filter: "invert(1) brightness(100%)",
                                            }}
                                          />
                                        ) : (
                                          <div
                                            style={{
                                              display: "inline-block",
                                              margin: "0px 10px 0px 0px",
                                            }}
                                          >
                                            <svg
                                              width="30"
                                              height="30"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <defs>
                                                <filter id="colorFilter">
                                                  <feColorMatrix
                                                    type="matrix"
                                                    values="0 0 0 0 0.337 0 0 0 0 0.337 0 0 0 0 0.337 0 0 0 1 0"
                                                  />
                                                </filter>
                                              </defs>
                                              <image
                                                href={optionImages[option.type]}
                                                x="0"
                                                y="0"
                                                width="24"
                                                height="24"
                                                style={{ filter: "url(#colorFilter)" }}
                                              />
                                            </svg>
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <div
                                        style={{
                                          display: "inline-block",
                                          margin: "0px 10px 0px 0px",
                                        }}
                                      >
                                        <svg
                                          width="30"
                                          height="30"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <defs>
                                            <filter id="colorFilter">
                                              <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0.337 0 0 0 0 0.337 0 0 0 0 0.337 0 0 0 1 0"
                                              />
                                            </filter>
                                          </defs>
                                          <image
                                            href={optionImages[option.type]}
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                            style={{ filter: "url(#colorFilter)" }}
                                          />
                                        </svg>
                                      </div>
                                    )}
                                    <span style={{ position: "relative", zIndex: 99 }}>{option.optionName}</span>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}




          </Slider>
        </div>
      </div>

      {
        Data?.length > 0 && <div
          className=" text-black flex justify-center items-center hideinpc grrominmobile"
          style={{ maxHeight: "100svh", overflow: "hidden" }}
        >
          <div
            style={{
              height: "100svh",
              width: "100%",
              position: "absolute",
              zIndex: "-99",
            }}
          >
            {Data.map((image, index) => (
              <img
                key={index}
                src={image.img}

                className={`crossFade__image ${currentSlide === index ? "crossFade__image--active" : ""
                  }
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                  }
											`}
                onLoad={() => setIsImageLoaded(false)}
                style={{
                  objectFit: "cover",
                  opacity: currentSlide === index ? 1 : 0,
                }}
              />
            ))}
          </div>
          <div
            className="progress-bar-container"
            style={{
              position: "absolute",
              top: 0,
              width: "100%",
              display: "flex",
            }}
          >
            {Data.map(
              (_, index) =>
                index > 0 &&
                index < Data.length - 1 && (
                  <div
                    className="progress-bar"
                    key={index}
                    style={{ flex: 1, margin: "0 2px" }}
                  >
                    <div
                      className="progress"
                      style={{
                        height: "4px",
                        backgroundColor: "#76c7c0",
                        width: `${progress[index]}%`,
                        transition: "width 0.5s ease",
                      }}
                    ></div>
                  </div>
                )
            )}
          </div>

          <Slider
            {...settings1}
            ref={sliderRef1}
            style={{ height: "100svh", maxWidth: "100%" }}
          >
            {Data.map((data, index) => (
              <div className="p-0 " style={{ width: "100%" }}>
                <div
                  className="p-5 flex justify-center flex-col items-center "
                  style={{ height: "100svh", width: "100%" }}
                >
                  <div
                    style={{ width: "100%" }}
                    className={`quiz ${shake ? "shake" : `${forward ? "forward" : ""}`
                      }`}
                  >
                    <div
                      className=" p-3 text-white text-center "
                      style={{
                        fontSize: "20px",
                        backgroundColor: "#262626",
                        fontWeight: "600",
                      }}
                    >
                      {data.id !== 0 ? (
                        <>{data.title}</>
                      ) : (
                        <>
                          {" "}
                          <u style={{ textTransform: "uppercase" }}>
                            {data.title}
                          </u>
                        </>
                      )}{" "}
                      <br />
                      {Data.length - 1 ? (
                        ""
                      ) : (
                        <p className="mb-0" style={{ paddingTop: "5px" }}>
                          {" "}
                          {data.line}
                        </p>
                      )}
                    </div>
                    <div className="p-2 px-3 flex flex-col items-center justify-center  ">
                      {data.id === Data[0].id ||
                        data.id === Data[Data.length - 1].id ? (
                        <>
                          <div className="p-2">
                            {data.id === Data[Data.length - 1].id && (
                              <img
                                src={data.img}
                                style={{
                                  height: "70px",
                                  width: "70px",
                                  borderRadius: "50%",
                                }}
                                //                className={`
                                // 			transition-all duration-500 ${
                                // 	isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                                // }
                                // 			`}
                                onLoad={() => setIsImageLoaded(false)}
                                alt=""
                              />
                            )}
                          </div>
                          <p
                            className="mb-1 px-3"
                            style={{
                              fontWeight: "550",
                              fontSize: "19px",
                              fontWeight: "600",
                              lineHeight: "30px",
                              textAlign: "center",
                              textAlignLast: "center",
                              color:
                                data.id === Data[0].id ? "#545454" : "#545454",
                            }}
                          >
                            {data.content}
                          </p>
                          <p
                            className="mb-1 "
                            style={{
                              fontWeight: "400",
                              fontSize: "17px",
                              textAlign: "justify",
                              textAlignLast: "center",
                              color: "#545454",
                            }}
                          >
                            {(() => {
                              if (data.id === Data[Data.length - 1].id) {
                                const score = yourscore;
                                const messages = data.resultMessages;
                                if (!messages) return data.text;

                                if (score === 0) return messages.zero;
                                if (score < 10) return messages.zeroToNine;
                                if (score < 20) return messages.tenToNinteen;
                                if (score < 30) return messages.twentyToTwentyNine;
                                if (score < 40) return messages.thirtyToThirtyNine;
                                if (score < 50) return messages.fourtyToFourtyNine;
                                if (score < 60) return messages.fiftyToFiftyNine;
                                if (score < 70) return messages.sixtyToSixtyNine;
                                if (score < 80) return messages.seventyToSeventyNine;
                                if (score < 90) return messages.eightyToEightyNine;
                                return messages.ninetyToHundread;
                              }
                              return data.text;
                            })()}
                          </p>

                          {data.id === Data[Data.length - 1].id ? (
                            <div
                              className=" -500 font-bold rounded p-2 pt-0 flex items-center flex-col "
                              style={{ width: "100%" }}
                            >
                              <div className="flex justify-center items-center">
                                <p
                                  style={{ fontSize: "18px", color: "#545454" }}
                                  className="mb-0"
                                >
                                  {" "}
                                  You Score :{" "}
                                </p>
                                <div className="pl-2 pr-1">
                                  <svg
                                    width="25"
                                    height="25"
                                    viewBox="0 0 24 24"
                                    fill="#e74c3c" /* Desired color */
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                  </svg>
                                </div>
                                <span
                                  style={{
                                    color: "#e74c3c",
                                    fontSize: "22px",
                                    fontWeight: "600",
                                    display: "inline-block",
                                  }}
                                >
                                  {" "}
                                  {yourscore}
                                </span>
                              </div>
                              {/* <button
                              className=" text-white p-1 m-2 py-2 mb-3 buttonripple"
                              style={{
                                width: "100%",
                                borderRadius: "20px",
                                backgroundColor: "#1BD04F",
                                fontWeight: "400",
                                textTransform: "uppercase",
                              }}
                              onClick={handleDownload}
                            >
                              Share
                            </button> */}
                              <BackButton
                                style={{ width: "100%", borderRadius: "20px" }}
                              >
                                <button
                                  className=" text-white p-1 py-2 buttonripple"
                                  style={{
                                    width: "100%",
                                    borderRadius: "20px",
                                    backgroundColor: "#e74c3c",
                                    fontWeight: "500",
                                    textTransform: "uppercase",
                                  }}
                                  onClick={() => handleButtonClick(data)}
                                >
                                  Exit
                                </button>
                              </BackButton>
                            </div>
                          ) : (
                            <button
                              className=" text-white p-2 m-2 buttonripple"
                              style={{
                                width: "90%",
                                borderRadius: "20px",
                                backgroundColor: "#1BD04F",
                                textTransform: "uppercase",
                              }}
                              onClick={() => handleButtonClick(data)}
                            >

                              <span style={{ position: "relative", zIndex: 1 }}>Start Quiz</span>

                            </button>
                          )}
                        </>
                      ) : (
                        <>
                          {data.options.map((option) => (
                            <div
                              key={option.id}
                              className={`option buttonripple  ${getOptionClass(
                                option.id,
                                index
                              )}`}
                              onClick={() => handleOptionClick(option.id, index)}
                              style={{
                                backgroundColor:
                                  option.id ===
                                    selectedOptions[index]?.correctOptionId
                                    ? "#1BD04F" // Green for correct option
                                    : option.id ===
                                      selectedOptions[index]?.optionId
                                      ? "#e74c3c"
                                      : "transparent",
                                color:
                                  option.id ===
                                    selectedOptions[index]?.correctOptionId
                                    ? "white" // Green for correct option
                                    : option.id ===
                                      selectedOptions[index]?.optionId
                                      ? "white"
                                      : "#545454",

                                borderColor:
                                  option.id ===
                                    selectedOptions[index]?.correctOptionId
                                    ? "#1BD04F" // Green for correct option
                                    : option.id ===
                                      selectedOptions[index]?.optionId
                                      ? "#e74c3c"
                                      : "",
                              }}
                            >
                              <div
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                {isSubmittedState[index] ? (
                                  <>
                                    {option.id ===
                                      selectedOptions[index]?.correctOptionId ? (
                                      <img
                                        src="/img/insta_check.svg"
                                        alt="Correct"
                                        style={{
                                          height: "30px",
                                          minWidth: "30px",
                                          margin: "0px 10px 0px 0px",
                                          filter: "invert(1) brightness(100%)",
                                        }}
                                      />
                                    ) : option.id ===
                                      selectedOptions[index]?.optionId ? (
                                      <img
                                        src="/img/insta_cancel.svg"
                                        alt="Wrong"
                                        style={{
                                          height: "30px",
                                          minWidth: "30px",
                                          margin: "0px 10px 0px 0px",
                                          filter: "invert(1) brightness(100%)",
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          display: "inline-block",
                                          margin: "0px 10px 0px 0px",
                                          width: "30px",
                                        }}
                                      >
                                        <svg
                                          width="30"
                                          height="30"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <defs>
                                            <filter id="colorFilter">
                                              <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0.337 0 0 0 0 0.337 0 0 0 0 0.337 0 0 0 1 0"
                                              />
                                            </filter>
                                          </defs>
                                          <image
                                            href={optionImages[option.type]}
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                            style={{
                                              filter: "url(#colorFilter)",
                                            }}
                                          />
                                        </svg>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <div
                                    style={{
                                      display: "inline-block",
                                      margin: "0px 10px 0px 0px",
                                      minWidth: "30px",
                                    }}
                                  >
                                    <svg
                                      width="30"
                                      height="30"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <defs>
                                        <filter id="colorFilter">
                                          <feColorMatrix
                                            type="matrix"
                                            values="0 0 0 0 0.337 0 0 0 0 0.337 0 0 0 0 0.337 0 0 0 1 0"
                                          />
                                        </filter>
                                      </defs>
                                      <image
                                        href={optionImages[option.type]}
                                        x="0"
                                        y="0"
                                        width="24"
                                        height="24"
                                        style={{ filter: "url(#colorFilter)" }}
                                      />
                                    </svg>
                                  </div>
                                )}

                                <div>{option.optionName}</div>
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div>
            <div
              className={`flex justify-center items-center fade-in ${showContent ? "show" : ""
                }`}
              style={{
                position: "absolute",
                bottom: "0px",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                className={`bg-white  flex items-center py-1  ${shakes ? "bounce2" : ""
                  }`}
                style={{
                  borderRadius: "10px",
                  width: "100%",
                  maxWidth: "fit-content",
                  justifyContent: "space-evenly",
                }}
              >
                <div className="pl-2 pr-1">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 24 24"
                    fill="#e74c3c" /* Desired color */
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                  </svg>
                </div>

                <div>
                  <span
                    className="pr-2 pl-0"
                    style={{
                      color: "#e74c3c",
                      fontSize: "22px",
                      fontWeight: "600",
                      display: "inline-block",
                    }}
                  >
                    {yourscore}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default Quiz
